import { useRef, useEffect } from 'react';

/**
 * LighthouseBeamBg — 灯塔扫光层
 * 每 6 秒一次扫光 → 0→峰值→0，偶尔赋予页面"生命感"
 */
export default function LighthouseBeamBg() {
  const beamRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    let animId;
    const start = performance.now();

    const tick = (now) => {
      const elapsed = (now - start) % 6000;

      if (elapsed < 1800) {
        const progress = elapsed / 1800;
        const intensity = Math.sin(progress * Math.PI);
        if (beamRef.current) {
          beamRef.current.style.opacity = intensity * 0.15;
          beamRef.current.style.transform = `rotate(${-12 + progress * 24}deg)`;
        }
        if (glowRef.current) {
          glowRef.current.style.opacity = 0.15 + intensity * 0.85;
        }
      } else {
        if (beamRef.current) beamRef.current.style.opacity = 0;
        if (glowRef.current) glowRef.current.style.opacity = 0.1;
      }

      animId = requestAnimationFrame(tick);
    };

    animId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animId);
  }, []);

  return (
    <div className="absolute pointer-events-none" style={{ bottom: '15%', right: '25%', width: '35%', height: '50%' }}>
      <div
        ref={beamRef}
        className="absolute bottom-0 left-1/2 w-full h-full will-change-transform"
        style={{ transformOrigin: 'bottom center', opacity: 0 }}
      >
        <svg viewBox="0 0 100 200" preserveAspectRatio="none" className="w-full h-full" style={{ overflow: 'visible' }}>
          <defs>
            <linearGradient id="hs-beam-grad" x1="50" y1="200" x2="50" y2="0" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="rgba(242, 200, 100, 0.7)" />
              <stop offset="30%" stopColor="rgba(242, 185, 75, 0.35)" />
              <stop offset="70%" stopColor="rgba(242, 185, 75, 0.1)" />
              <stop offset="100%" stopColor="rgba(242, 185, 75, 0)" />
            </linearGradient>
          </defs>
          <polygon points="48,200 52,200 80,0 20,0" fill="url(#hs-beam-grad)" />
        </svg>
      </div>

      <div
        ref={glowRef}
        className="absolute bottom-0 left-1/2 w-3 h-3 rounded-full will-change-transform"
        style={{
          transform: 'translate(-50%, 50%)',
          background: 'radial-gradient(circle, rgba(242,200,100,0.8) 0%, rgba(242,200,100,0.3) 40%, transparent 70%)',
          boxShadow: '0 0 10px rgba(242,200,100,0.5)',
          filter: 'blur(1px)',
          opacity: 0.1,
        }}
      />
    </div>
  );
}
